import { differenceInCalendarDays, parse } from "date-fns";
const getNights = (checkIn = '', checkOut = '')=>{
    if (null == checkIn || null == checkOut || 'string' != typeof checkIn || 'string' != typeof checkOut || !checkIn || !checkOut || isNaN(Number(checkIn)) || isNaN(Number(checkOut))) return 1;
    const checkInDate = parse(checkIn, 'yyyyMMdd', new Date());
    const checkOutDate = parse(checkOut, 'yyyyMMdd', new Date());
    return Math.max(1, differenceInCalendarDays(checkOutDate, checkInDate));
};
const parsePrice = (value)=>{
    const num = Number(value);
    return isNaN(num) ? 0 : Math.round(num);
};
export { getNights, parsePrice };
